
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WebAppSharedModule } from '../../shared';
import { DatePipe } from '@angular/common';
import { TranslatePipeModule } from './../../../language/language.module';

import { AnnouncementRoute,  AnnouncementEditResolvePagingParams, AnnouncementResolvePagingParams } from './Announcement.route';
import { AnnouncementpreviewComponent, ItemPreviewAnnouncementPopupComponent } from './Announcement-preview/Announcement-preview.component';
import { Announcementservice } from './Announcement.service';
import { announcementPopupComponentservice } from './announcementPopupComponent.service';

const ENTITY_STATES = [
     ...AnnouncementRoute,
];

@NgModule({
    imports: [
        WebAppSharedModule,
        TranslatePipeModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true }),
    ],
    declarations: [
        ItemPreviewAnnouncementPopupComponent,
        AnnouncementpreviewComponent,
    ],
    entryComponents: [
        ItemPreviewAnnouncementPopupComponent,
        AnnouncementpreviewComponent,
        
    ],
    providers: [
        DatePipe,
        AnnouncementEditResolvePagingParams,
        AnnouncementResolvePagingParams,
        Announcementservice,
        announcementPopupComponentservice,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MWebAppAnnouncementModule {}
